import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaRocket,
  FaEye,
  FaStar,
  FaMobileAlt,
  FaBriefcase,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const BestVideoEditingCompanyInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Best Video Editing Company in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Transform Your Vision</Subheading>}
        heading={
          <Heading>
            Best <span tw="text-primary-500">Video Editing Company</span> in
            DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we are the leading video editing company in
            **DIFC**, delivering professional, high-impact videos that elevate
            your brand. Our expert editors craft visually stunning content
            tailored to your goals, ensuring your message resonates with
            audiences.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1593697972624-aedb9e6f7c67?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Professional video editing workstation
          "https://images.unsplash.com/photo-1536240478700-b869070f9279?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Video editor at work
          "https://images.unsplash.com/photo-1626785774573-4b799315345d?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Post-production setup
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Edit Your Video Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Premier Video Editing in DIFC"
        description="We deliver exceptional video editing services with precision and creativity."
        cards={[
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Expert Editors",
            description:
              "Skilled professionals with years of industry experience.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Tailored Storytelling",
            description: "Custom edits that align with your brand’s vision.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Stunning Visuals",
            description: "High-quality edits that captivate your audience.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Timely delivery without compromising quality.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Platform-Optimized",
            description: "Videos formatted for web, mobile, and social media.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted in DIFC",
            description: "Preferred choice for businesses in DIFC.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Professional Editing Process"
        description={
          <Description>
            We create polished videos through a streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your goals and vision.</li>
              <li>Planning: Develop a tailored editing strategy.</li>
              <li>Editing: Craft seamless, high-quality videos.</li>
              <li>Review: Incorporate feedback for perfection.</li>
              <li>Delivery: Provide ready-to-use, optimized videos.</li>
              <li>Support: Offer ongoing assistance and updates.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1535016120720-40c646be5580?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Video editing software screen
          "https://images.unsplash.com/photo-1528109966604-5a6a4a964e9f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Team editing collaboration
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Professional editing equipment
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Proven Results in DIFC"
        description="Our video editing services have driven measurable impact."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Increased Engagement",
            description: "Boosted video views by 200% for a DIFC client.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Visibility",
            description: "Enhanced brand reach for a financial firm.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "98% approval rate from DIFC businesses.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Professional Editing?</Subheading>}
        heading="Best Video Editing in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset, the best video editing company in DIFC,
            to create impactful, professional videos that elevate your brand.
            Contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1630332458162-61003d41cd41?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Professional video review
          "https://images.unsplash.com/photo-1600271886742-f049cd451bba?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Editing suite
          "https://images.unsplash.com/photo-1609921205586-7e8a57516512?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Video production monitors
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
